"use client";

import { Scripture } from "@jesus-central-church/ui";
import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { type SbScripture } from "@storyblok/types/287435740670216/storyblok-components";

export function ScriptureComponent({ blok }: { blok: SbScripture }) {
  return (
    <Scripture
      {...storyblokEditable(blok as SbBlokData)}
      badge={blok.badge ?? ""}
      scripture={blok.scripture}
      reference={blok.reference}
      textColor={blok.textColor as string}
      variant={blok.variant}
      accentColor={blok.accentColor}
    />
  );
}
